<template>
  <svg :class="svgClass" aria-hidden="true" :style="svgStyle">
    <use :xlink:href="symbolId"></use>
  </svg>
</template>

<script setup lang="ts">
const props = defineProps({
  name: {
    type: String,
    required: true
  },
  width: {
    type: String
  },
  height: {
    type: String
  }
})
const svgClass = computed(() => `svg-icon`)
const svgStyle = computed(() => {
  if (props.width && props.height) {
    return {
      width: `${props.width}px`,
      height: `${props.height}px`
    }
  }
  return {}
})
const symbolId = computed(() => `#icon-${props.name}`)
</script>

<style>
.svg-icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
</style>
